import * as React from 'react';
import { DefaultSortOrder, DomainNode } from 'ui/sort-order/types';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { SortByList } from 'ui/sort-order/sort-by-list/sort-by-list';
import { ModalSize } from 'app/components/constants';

interface SortOrderModalProps {
  options?: DomainNode[];
  translation?: any;
  onDone?: (sortOrderFields: DefaultSortOrder[]) => void;
  handleToggle: () => void;
  loadOptions: (query?: string) => void;
  sortOrderFields?: DefaultSortOrder[];
}

const SortOrderModal = ({ options, translation, onDone: onDoneCb, handleToggle, loadOptions, sortOrderFields: defaultFields }:
  SortOrderModalProps) => {

  const [sortOrderFields, setSortOrderFields] = React.useState<DefaultSortOrder[]>(defaultFields);
  const onDone = () => {
    onDoneCb(sortOrderFields);
  };

  return <ModalWrapper
    headerTitle={translation.sort_order_title}
    btnTitle={translation.sort_order_button_done}
    onClose={handleToggle}
    onDone={onDone}
    size={ModalSize.large}>
    <SortByList
      options={options || []}
      translation={translation}
      loadOptions={loadOptions}
      sortOrderFields={sortOrderFields}
      setSortOrderFields={setSortOrderFields}
    />
  </ModalWrapper>;
};

export { SortOrderModal };
